// Combo's cloud inputs. Its corpus is the drilled level rather than the answer root, and it
// carries a breadcrumb of the levels above it where the rest of the family carries the active
// word. The words table inside the cloud only stands in at a leaf, where there is no level
// left for the scope list under it to show.

import { ROOT_SCOPE, buildWords, resolveAnswerVariants } from '@aytm/app/stats/page/question-views/cx/lib/scope'
import { calcScopedAnswerVariants } from '@aytm/app/stats/page/question-views/cx/lib/props/table'
import { calcWcProps as calcOeWcProps } from '@aytm/app/stats/page/question-views/oe/lib/props/word-cloud'

export const calcWcScope = ({ scope = [], answerVariants }) => {
  const path = []
  const prefix = []

  for (const s of scope) {
    if (null == s || ROOT_SCOPE === s) break

    const variants = resolveAnswerVariants(prefix, answerVariants) || []
    const variant = variants.find(av => av?.position === s)

    path.push({ id: s, text: variant?.text || `A${s}` })
    prefix.push(s)
  }

  return path
}

export const calcRawData = ({ levels = 1, scope, answer, answerVariants } = {}) => ({
  words: buildWords(levels, scope, answer, answerVariants)
})

// The cloud fields combo never offers. A cx word triple carries the variant position in the slot
// the stop-level filters read, so those filters must be off or the a1 / a2 words vanish.
export const calcRejects = type => ({
  maxWords: 300,
  ...('cx' === type ? { stop1: 0, stop2: 0, stop3: 0, stop4: 0, stop5: 0 } : {})
})

export const calcWcProps = inputs => {
  const { scope, answerVariants, components, rawData } = inputs

  const scoped = calcScopedAnswerVariants({ scope, answerVariants })

  const props = calcOeWcProps({
    ...inputs,
    rawData: rawData || calcRawData(inputs),
    components: { ...(components || {}), table: !scoped.length }
  })

  return { ...props, data: { ...props.data, scope: calcWcScope({ scope, answerVariants }) } }
}
